import React, { Component } from "react";
import { NavLink, Outlet,Link  } from "react-router-dom";
import { styled } from "@mui/material/styles";
import {
    Box,
    IconButton,
    Typography,
    Divider,
    List,
    ListItemButton,
    ListItemText,
    Collapse,
    Avatar,
    InputBase
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import NotificationsIcon from "@mui/icons-material/Notifications";
import LockIcon from "@mui/icons-material/Lock";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "./images/INNER-PAGE-LOGO.jpg";
import changepwd from "./images/CHANGE-PASSWORD-ICON.jpg";
import costIcon from "./images/CONTRACTORS-ICON.jpg";
import reportIcon from "./images/REPORTS-ICON.jpg";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import RedoIcon from '@mui/icons-material/Redo';
const drawerWidth = 280;
const Root = styled(Box)(()=>({
    display:"flex",
    width:"100%",
    minHeight:"100vh",
    overflow:"hidden"
}));
const Sidebar = styled(Box)(({open})=>({
    width:drawerWidth,
    height:"100vh",
    position:"fixed",
    top:0,
    left:open ? 0 : -drawerWidth,
    background:"#156dd9",
    color:"#fff",
    transition:"0.3s ease",
    padding:"25px 0px",
    boxSizing:"border-box",
    zIndex:1200
}));
const MainContent = styled(Box)(({open})=>({
    width:"100%",
    marginLeft:open ? drawerWidth : 0,
    transition:"0.3s ease",
}));
class MasterLayout extends React.Component {
constructor(props){
super(props);
this.state={
    sidebar:true,payments:true,
    master:false,
    reports:false
};
}
toggleSidebar=()=>{
this.setState({
    sidebar:!this.state.sidebar
});
}
toggleMaster=()=>{
this.setState({
payments:false,
    master:!this.state.master,
reports:false
});
}
togglepayments=()=>{
this.setState({
 master:false,reports:false,
    payments:!this.state.payments
});
}
toggleReports=()=>{
this.setState({
 master:false,payments:false,
    reports:!this.state.reports
});
}
render(){
const {
payments,
sidebar,
master,
reports
}=this.state;
return(
<Root>
{/* LEFT SIDEBAR */}
<Sidebar open={sidebar}>
<Box
sx={{
display:"flex",
alignItems:"center",
justifyContent:"space-between"
}}
>
<img
src={logo}
className="logosidebar"
alt="logo"
/>
<IconButton
onClick={this.toggleSidebar}
sx={{color:"#fff"}}
>
<ChevronLeftIcon/>
</IconButton>
</Box>
<Divider
sx={{
background:"#ffffff40",
my:1
}}
/>
<List sx={{ paddingTop: "0px"}} className="Matersidemenu">
{/* MASTER */}
<ListItemButton key="Dashboard"
component={Link}
to={"/Dashboard"}
sx={{pl:4}}>
<ListItemText
primary="Dashboard"
/>
</ListItemButton>
<ListItemButton
onClick={this.toggleMaster}
sx={{
    backgroundColor: master ? "#0ae6f4" : "transparent",
color:master ? "#000" : "#fff",
    "&:hover":{
        backgroundColor:"#0ae6f4"
    }
}}component={Link}
to={"#"}
>
<ListItemText
primary="Masters"
/>
{
master
?
<ExpandLess/>
:
<ExpandMore/>
}
</ListItemButton>
<Collapse
in={master}
unmountOnExit
>
<List>
{
[
{
        name:"User Management",
        path:"/User"
    },
{
        name:"Parameters",
        path:"/OperationalParameters"
    },
 {
        name:"Wages Category",
        path:"/Wages"
    },
	 {
        name:"Materials",
        path:"/Materials"
    },
	 {
        name:"Expense & Services",
        path:"/Expensesandservices"
    },
	 {
        name:"Vendor Management",
        path:"/Vendorandcontract"
    },
 {
        name:"Projects",
        path:"/Projects"
    },
].map((item)=>(
<ListItemButton
key={item.name}
component={Link}
to={item.path}
sx={{pl:4}}
>
<ListItemText
primary={"• "+item.name}
/>
</ListItemButton>
))
}
</List>
</Collapse>
{/* CONTRACTOR */}
<ListItemButton key="Contractor Cost Mappin"
component={Link}
to={"/ContractCostMap"}
sx={{pl:4}}>
<ListItemText
primary="Contractor Cost Mapping"
/>
</ListItemButton>
<ListItemButton key="Material Procurement"
component={Link}
to={"/Projectwise-materials"}
sx={{pl:4}}>
<ListItemText
primary="Material Procurement"
/>
</ListItemButton>
<ListItemButton key="Update Materials Amount"
component={Link}
to={"/MaterialAmountEntry"}
sx={{pl:4}}>
<ListItemText
primary="Update Materials Amount"
/>
</ListItemButton>
<ListItemButton
onClick={this.togglepayments}
sx={{
    backgroundColor: payments ? "#0ae6f4" : "transparent",
color:payments ? "#000" : "#fff",
    "&:hover":{
        backgroundColor:"#0ae6f4"
    }
}}component={Link}
to={"#"}
>
<ListItemText
primary="Payments"
/>
{
payments
?
<ExpandLess/>
:
<ExpandMore/>
}
</ListItemButton>
<Collapse
in={payments}
unmountOnExit
>
<List>
{
[
{
        name:"Pay Now",
        path:"/Paymenttransactions"
    },
{
        name:"Vendor Payments",
        path:"/Transactions"
    },
		{
        name:"Customer Payments",
        path:"/CustomerPayment"
    },
	{
        name:"Expenses",
        path:"/Expensedisplay"
    },
	
].map((item)=>(
<ListItemButton
key={item.name}
component={Link}
to={item.path}
sx={{pl:4}}
>
<ListItemText
primary={"• "+item.name}
/>
</ListItemButton>
))
}
</List>
</Collapse>
{/* REPORTS */}
<ListItemButton
onClick={this.toggleReports}
sx={{
    backgroundColor: reports ? "#0ae6f4" : "transparent",
color:reports ? "#000" : "#fff",
    "&:hover":{
        backgroundColor:"#0ae6f4"
    }
}}component={Link}
to={"#"}
>
<ListItemText
primary="Reports"
/>
{
reports
?
<ExpandLess/>
:
<ExpandMore/>
}
</ListItemButton>
<Collapse
in={reports}
unmountOnExit
>
<List>
{
[
{
        name:"Wages",
        path:"/WagesReport"
    },
{
        name:"Material Purchases",
        path:"/MaterialPurchase-report"
    },
		{
        name:"Profitable Report",
        path:"/ProfitableReport"
    },
	{
        name:"Project Ledger",
        path:"/ProjectLedgerReport"
    },{
        name:"Vendor Ledger",
        path:"/VendorLedgerReport"
    }
	,
	{
        name:"Expenses Ledger",
        path:"/Expense-report"
    },
	{
        name:"Pending Payments",
        path:"/PendingPayments"
    },
	{
        name:"Payments Out Report",
        path:"/PaymentOutReport"
    },
	{
        name:"Payments Pending In",
        path:"/Projectpaymentduereport"
    },
].map((item)=>(
<ListItemButton
key={item.name}
component={Link}
to={item.path}
sx={{pl:4}}
>
<ListItemText
primary={"• "+item.name}
/>
</ListItemButton>
))
}
</List>
</Collapse>
</List>
{/* BOTTOM BUTTONS */}
<Box
sx={{
bottom:30,
left:25,
right:25,
padding:"0px 25px"
}}
>
<ListItemButton
sx={{
border:"1px solid #fff",
borderRadius:"25px",
mb:2
}}
to={"/change-password"}
>
<LockIcon/>
<ListItemText
primary="Change Password"
/>
</ListItemButton>
<ListItemButton
sx={{
background:"#19dff5",
borderRadius:"25px",
color:"#003"
}}
to={"/Logout"}
>
<LogoutIcon/>
<ListItemText
primary="Logout"
to={"/Logout"}
/>
</ListItemButton>
</Box>
</Sidebar>
{/* RIGHT CONTENT */}
<MainContent open={sidebar}>
{/* HEADER */}
<Box
sx={{
height:"80px",
background:"#fff",
borderBottom:"1px solid #ddd",
display:"flex",
alignItems:"center",
px:3
}}
>
{this.state.sidebar ===false &&(
<IconButton
onClick={this.toggleSidebar}
sx={{color:"#19477D"}}
>
<MenuIcon/>
</IconButton>
)}
<Box
sx={{
ml:"auto",
display:"flex",
alignItems:"center"
}}
>
<Box sx={{mr:2}}className="headersec">
<h3
>
Hello, {localStorage.getItem("VRName")}
</h3>
<Typography fontSize="13px">
Welcome to VR Builder
</Typography>
</Box>
<Avatar src="/profile.png"/>
</Box>
</Box>
{/* PAGE CONTENT */}
<Box
sx={{
p:3,
background:"#e7e7e7",
minHeight:"calc(100vh - 80px)"
}}
className="masterlayout"
>
<div className="adminmain">
<div className="layoutbgcolr">
 <div className="pageheadr">
 <h2>{this.props.heading}
 
 {this.props.heading==="Enter Project" && (
 <a href="/Projects">
 <RedoIcon className="alignright" /></a>
 )}
  {this.props.heading==="Enter Expenses" && (
 <a href="/Expensedisplay">
 <RedoIcon className="alignright" /></a>
 )}
   {this.props.heading==="Material Procurement Entry" && (
 <a href="/Projectwise-materials">
 <RedoIcon className="alignright" /></a>
 )}

 </h2>
	   </div>
	   <div className="layoutpadd">
<Outlet/>
</div>
</div>
</div>
</Box>
<Box
sx={{
height:60,
borderTop:"1px solid #ddd",
display:"flex",
alignItems:"center",
justifyContent:"center"
}}
>
<Typography
fontSize="14px"
>
© Copyright {new Date().getFullYear()} VR Builders® . All Rights Reserved
</Typography>
</Box>
</MainContent>
</Root>
)
}
}
export default MasterLayout;